

//export const CurrentUrl = "http://testing.ivikas.in/"
//export const CurrentUrl ="https://localhost:44355/"
// export const CurrentUrl ="https://sb244wz6-44355.inc1.devtunnels.ms/"
//export const CurrentUrl = "https://newapi.mvload.in/"
export const CurrentUrl = "https://b2capi.mvload.in/"
